import { URL } from '../variables';

export async function requestAdminAuthentication(path, data) {
    const response = await fetch(`${URL}api/faculdade/auth/${path}`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    const result = await response.json().catch(() => null);
    if (!result) throw new Error('Não foi possível ler a resposta do servidor. Tente novamente.');
    if (!response.ok || result.errors || result.error) {
        const fields = Object.values(result.errors || {}).flat();
        const error = new Error(fields.join('\n') || result.message || 'Não foi possível concluir o acesso.');
        error.type = result.error_type;
        error.retryAfter = Number(result.retry_after) || 0;
        throw error;
    }
    return result;
}
